import React from 'react'

import AdminActions from '../../../../actions/AdminActions.js'

import {formSpacing, FormStack, Input} from '../../../../components/UI/forms/index.js'
import {Alert, Button, Modal, ModalHeader, ModalActions, P} from '../../../../components/UI/index.js'

class RemovePopup extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            isOpen: false,
            reseller: {},
            name: '',
            loading: false,
            error: ''
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(reseller) {
        this.setState({isOpen: true, reseller})
    }

    close() {
        this.setState(this.initialState)
    }

    onClickConfirm() {
        const {reseller, name} = this.state

        if (reseller.name === name) {
            this.setState({loading: true, error: ''})

            AdminActions.removeReseller(reseller._id, (err) => {
                if (err) {
                    this.setState({loading: false, error: err})
                } else {
                    this.close()
                }
            })
        } else {
            this.setState({error: 'De ingevulde naam komt niet overeen met de resellernaam.'})
        }
    }

    render() {
        const {isOpen, reseller, name, loading, error} = this.state

        return (
            <Modal show={isOpen} style={{width: 400}} onClose={this.close.bind(this)}>

                <ModalHeader title='Verwijder reseller' />

                <P style={{marginBottom: 30}}>
                    {`Let op! Reseller ${reseller.name} inclusief alle gebruikers worden definitief verwijderd. Vul hieronder de resellernaam in om door te gaan.`}
                </P>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Naam'
                        value={name}
                        onChange={(event) => this.setState({name: event.target.value})}
                    />
                </FormStack>

                {error &&
                    <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                }

                <ModalActions>
                    <Button
                        variant='text'
                        onClick={this.close.bind(this)}
                    >
                        Annuleren
                    </Button>
                    <Button
                        variant='text'
                        loading={loading}
                        onClick={this.onClickConfirm.bind(this)}
                    >
                        Bevestigen
                    </Button>
                </ModalActions>
            </Modal>
        )
    }
}

export default (RemovePopup)
